import React from "react";

import { Dropdown, Grid, Button } from "semantic-ui-react";

function RegisterByAdmin({
  options,
  isLoading,
  selectedMemberId,
  selectMemberId,
  onSearchChange,
  onRegister
}) {
  return (
    <Grid stackable>
      <Grid.Row>
        <Grid.Column width={8}>
          <Dropdown
            fluid
            selection
            clearable
            multiple={false}
            search={true}
            options={options}
            value={selectedMemberId}
            placeholder="Add Member"
            onChange={(_, { value }) => selectMemberId(value)}
            onSearchChange={(_, { searchQuery }) => {
              onSearchChange(searchQuery);
            }}
            disabled={isLoading}
            loading={isLoading}
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <Button primary disabled={!selectedMemberId} onClick={onRegister}>
            Anmelden
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

RegisterByAdmin.displayName =
  "coursePlan/details/registrations/RegisterByAdmin";

export default React.memo(RegisterByAdmin);
